export default "__VITE_ASSET__B7H4PM40__"